import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "../../store/reducer/projectSlice";
import { editProfileApiCall } from "../../store/actions/projectAction";

function PersonalInfoForm() {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();

  const dispatch = useDispatch();

  const user = useSelector((state) => state.project.user);

  console.log(user, "user");

  const onSubmit = async (data) => {
    try {
      dispatch(
        setLoading({
          code: "profile_change",
          loading: true,
        })
      );

      await dispatch(
        editProfileApiCall({
          data: {
            name: data.username,
            email: data.email,
            phone: data.phone,
          },
        })
      );

      dispatch(
        setLoading({
          code: "profile_change",
          loading: false,
        })
      );
    } catch (error) {
      console.log(error, "error");
      dispatch(
        setLoading({
          code: "profile_change",
          loading: false,
        })
      );
    }
  };

  useEffect(() => {
    if (user) {
      setValue("username", user.name);
      setValue("email", user.email);
      setValue("phone", user.phone);
    }
  }, [user, setValue]);

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className="bg-white p-6 rounded-xl shadow-md mb-10 border border-gray-200"
    >
      <h2 className="text-xl font-semibold text-gray-700 mb-6 border-b pb-3">
        Personal Information
      </h2>
      <div className="space-y-5">
        <div>
          <label className="block text-sm font-medium text-gray-600 mb-1">
            Username
          </label>
          <input
            {...register("username", { required: "Username is required" })}
            placeholder="John Doe"
            className="w-full border px-4 py-2 rounded-lg focus:ring-2 focus:ring-blue-500"
          />
          {errors.username && (
            <p className="text-red-500 text-sm mt-1">
              {errors.username.message}
            </p>
          )}
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-600 mb-1">
            Email
          </label>
          <input
            type="email"
            {...register("email", {
              required: "Email is required",
              pattern: {
                value: /^\S+@\S+$/i,
                message: "Invalid email address",
              },
            })}
            disabled
            placeholder="john@example.com"
            className="w-full border px-4 py-2 rounded-lg focus:ring-2 focus:ring-blue-500"
          />
          {errors.email && (
            <p className="text-red-500 text-sm mt-1">{errors.email.message}</p>
          )}
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-600 mb-1">
            Phone Number
          </label>
          <input
            type="tel"
            {...register("phone", {
              required: "Phone number is required",
              pattern: {
                value: /^[0-9]{10}$/,
                message: "Enter a valid 10-digit phone number",
              },
            })}
            placeholder="9876543210"
            className="w-full border px-4 py-2 rounded-lg focus:ring-2 focus:ring-blue-500"
          />
          {errors.phone && (
            <p className="text-red-500 text-sm mt-1">{errors.phone.message}</p>
          )}
        </div>

        <button
          type="submit"
          className="bg-[#00428C] text-white px-6 py-2 rounded-lg mt-4 hover:bg-blue-700"
        >
          Save Info
        </button>
      </div>
    </form>
  );
}

export default PersonalInfoForm;
